import { render, staticRenderFns } from "./SectionMapYarmarka.vue?vue&type=template&id=0a2b729f&scoped=true"
import script from "./SectionMapYarmarka.vue?vue&type=script&lang=ts"
export * from "./SectionMapYarmarka.vue?vue&type=script&lang=ts"
import style0 from "./SectionMapYarmarka.vue?vue&type=style&index=0&id=0a2b729f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b729f",
  null
  
)

export default component.exports